export default __webpack_public_path__ + "static/media/Astrana_Logo_Plum.cc3fcf66.svg";